<div class="portion-list">
  <div class="portion-list__title">
    <span i18n="@@NutritionalValue">Nutritional value per {{ size.portionWeightGrams }}</span>

    <ng-container [ngSwitch]="size.measureUnitType">
      <span *ngSwitchCase="'GRAM'" i18n="@@WeightGramUnit">g</span>
      <span *ngSwitchCase="'MILLILITER'" i18n="@@WeightMlUnit">ml</span>
      <span *ngSwitchCase="'KILOGRAM'" i18n="@@WeightKgUnit">kg</span>
      <span *ngSwitchCase="'LITER'" i18n="@@WeightLUnit">l</span>
      <span *ngSwitchDefault="'GRAM'" i18n="@@WeightGramUnit">g</span>
    </ng-container>

    <span i18n="@@NutritionalValueOfProduct">of product</span>
  </div>

  <div class="portion-list__inner" *ngIf="size.portionWeightGrams">
    <div class="portion-list__item" *ngIf="nutrition && nutrition.proteins">
      <div class="portion-list__label small" i18n="@@ProductInfoProteins">Protein</div>
      <div class="portion-list__value small">
        <ng-container *ngIf="size.measureUnitType === 'GRAM' || size.measureUnitType === 'MILLILITER'">
          {{ (nutrition.proteins * size.portionWeightGrams / 100).toFixed(1) }}
        </ng-container>
        <ng-container *ngIf="size.measureUnitType === 'KILOGRAM' || size.measureUnitType === 'LITER'">
          {{ (nutrition.proteins * size.portionWeightGrams * 10).toFixed(1) }}
        </ng-container>
        <span i18n="@@WeightGramUnit">g</span>
      </div>
    </div>

    <div class="portion-list__item" *ngIf="nutrition && nutrition.fats">
      <div class="portion-list__label small" i18n="@@ProductInfoFats">Fats</div>
      <div class="portion-list__value small">
        <ng-container *ngIf="size.measureUnitType === 'GRAM' || size.measureUnitType === 'MILLILITER'">
          {{ (nutrition.fats * size.portionWeightGrams / 100).toFixed(1) }}
        </ng-container>
        <ng-container *ngIf="size.measureUnitType === 'KILOGRAM' || size.measureUnitType === 'LITER'">
          {{ (nutrition.fats * size.portionWeightGrams * 10).toFixed(1) }}
        </ng-container>
        <span i18n="@@WeightGramUnit">g</span>
      </div>
    </div>

    <div class="portion-list__item" *ngIf="nutrition && nutrition.carbs">
      <div class="portion-list__label small" i18n="@@ProductInfoCarbs">Carb</div>
      <div class="portion-list__value small">
        <ng-container *ngIf="size.measureUnitType === 'GRAM' || size.measureUnitType === 'MILLILITER'">
          {{ (nutrition.carbs * size.portionWeightGrams / 100).toFixed(1) }}
        </ng-container>
        <ng-container *ngIf="size.measureUnitType === 'KILOGRAM' || size.measureUnitType === 'LITER'">
          {{ (nutrition.carbs * size.portionWeightGrams * 10).toFixed(1) }}
        </ng-container>
        <span i18n="@@WeightGramUnit">g</span>
      </div>
    </div>

    <div class="portion-list__item" *ngIf="nutrition && nutrition.energy">
      <div class="portion-list__label small" i18n="@@ProductInfoEnergy">Calories</div>
      <div class="portion-list__value small">
        <ng-container *ngIf="size.measureUnitType === 'GRAM' || size.measureUnitType === 'MILLILITER'">
          {{ (nutrition.energy * size.portionWeightGrams! / 100).toFixed(1) }}
        </ng-container>
        <ng-container *ngIf="size.measureUnitType === 'KILOGRAM' || size.measureUnitType === 'LITER'">
          {{ (nutrition.energy * size.portionWeightGrams! * 10).toFixed(1) }}
        </ng-container>
        <span i18n="@@EnergyUnit">kcal</span>
      </div>
    </div>

    <div class="portion-list__item" *ngIf="nutrition && nutrition.salt">
      <div class="portion-list__label small" i18n="@@ProductInfoSalt">Salt</div>
      <div class="portion-list__value small">
        <ng-container [ngSwitch]="size.measureUnitType">
          <span *ngSwitchCase="'GRAM' || 'MILLILITER'">
            {{ (nutrition.salt * size.portionWeightGrams / 100).toFixed(1) }} </span>
          <span *ngSwitchCase="'KILOGRAM' || 'LITER'">
            {{ (nutrition.salt * size.portionWeightGrams * 10).toFixed(1) }} </span>
        </ng-container>

        <span i18n="@@WeightGramUnit">g</span>
      </div>
    </div>

    <div class="portion-list__item" *ngIf="nutrition && nutrition.saturatedFattyAcid">
      <div class="portion-list__label small" i18n="@@ProductInfoSaturatedFattyAcid">SFA</div>
      <div class="portion-list__value small">
        <ng-container [ngSwitch]="size.measureUnitType">
          <span *ngSwitchCase="'GRAM' || 'MILLILITER'">
            {{ (nutrition.saturatedFattyAcid * size.portionWeightGrams / 100).toFixed(1) }} </span>
          <span *ngSwitchCase="'KILOGRAM' || 'LITER'">
            {{ (nutrition.saturatedFattyAcid * size.portionWeightGrams * 10).toFixed(1) }} </span>
        </ng-container>

        <span i18n="@@WeightGramUnit">g</span>
      </div>
    </div>

    <div class="portion-list__item" *ngIf="nutrition && nutrition.sugar">
      <div class="portion-list__label small" i18n="@@ProductInfoSugar">Sugar</div>
      <div class="portion-list__value small">
        <ng-container [ngSwitch]="size.measureUnitType">
          <span *ngSwitchCase="'GRAM' || 'MILLILITER'">
            {{ (nutrition.sugar * size.portionWeightGrams / 100).toFixed(1) }} </span>
          <span *ngSwitchCase="'KILOGRAM' || 'LITER'">
            {{ (nutrition.sugar * size.portionWeightGrams * 10).toFixed(1) }} </span>
        </ng-container>

        <span i18n="@@WeightGramUnit">g</span>
      </div>
    </div>

  </div>
</div>
